import styled from '@emotion/styled';
import ContentContainerComponent from 'components/publicWebsiteV2/common/ContentContainerComponent';

export const StyledContentContainerComponent = styled(ContentContainerComponent)`
  text-align: center;
`;

export const Form = styled.form<{ bgColor: string }>`
  padding: 60px ${props => props.theme?.SPACING?.S32};
  max-width: 800px;
  margin: ${props => props.theme?.SPACING?.LG} auto 0;
  border-radius: 20px;
  background-color: ${({ bgColor }) => bgColor};
`;

export const Instructions = styled.p`
  margin-bottom: ${props => props.theme?.SPACING?.S24};
`;

export const InputContainer = styled.div`
  max-width: 400px;
  margin: 0 auto ${props => props.theme?.SPACING?.S24};

  ${props => props.theme?.MEDIA_QUERY?.MOBILE} {
    margin-bottom: ${props => props.theme?.SPACING?.LG};
  }
`;
